import { useParams } from 'react-router-dom'
import EditActionForm from './EditActionForm'
import PulseLoader from 'react-spinners/PulseLoader'
import { useGetTaskBasesQuery } from '../taskBasesApiSlice'

const _EditAction = () => {

    const { actionId, taskBaseId } = useParams()
    const { taskBase } = useGetTaskBasesQuery("taskBasesList", {
        selectFromResult: ({ data }) => {
            return {
                taskBase: data?.find(x=>x._id ===taskBaseId)
            }
        },
    })
    if (!taskBase) return <PulseLoader color={"#FFF"} />

    const action = taskBase.actions?.find(ac=>ac._id === actionId)


    if (!action) return <PulseLoader color={"#FFF"} />



    const content = <EditActionForm action={action}  />

    return content
}
export default _EditAction